const INACTIVE = 'INACTIVE';

const getMostRecentEventId = eventData =>
  [...eventData].sort(data => data.created).pop()?.id;

export function getConference(conference) {
  return {
    ...conference,
    eventId: getMostRecentEventId(conference.events.data),
    icon:
      conference.status === INACTIVE
        ? 'icon-remove-circle'
        : 'conference_active',
    participants: conference.activeParticipantCount || 0,
  };
}
